import { useCurrentRoute } from '@common/hooks';
import { MacroType } from '@common/models/Enums/MacroType';
import { CommunicationTemplateSearchStore } from '@common/stores/CommunicationTemplateSearchStore';
import { useHospitalApp } from '@hospital/hooks';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router';
import { CommunicationTemplatesTable } from '../communicationTemplates';
import { UserStore } from './UserStore';

interface IUserProfileCommunicationTemplates {
    store: UserStore;
    readOnly?: boolean;
}

export const UserProfileCommunicationTemplates = observer(({ store, readOnly }: IUserProfileCommunicationTemplates) => {
    const navigate = useNavigate();
    const { currentHospital } = useHospitalApp();
    const [searchStore] = useState(new CommunicationTemplateSearchStore(MacroType.Provider, undefined, store.userId))
    const { userId } = useParams();
    const currentRoute = useCurrentRoute();
    const isAdmin = currentRoute?.pathname.toLowerCase().startsWith("/admin");
    const isMyProfile = currentRoute!.pathname.toLowerCase().includes('/myprofile');
    const userProfileBaseUrl = isAdmin && !isMyProfile ? "../../users/" : "../";

    useEffect(() => {
        searchStore.search();
    }, [searchStore, searchStore.combinedSearchParams, userId]);

    const onCommunicationTemplateSelected = (id: number) =>
        navigate(`${userProfileBaseUrl}${userId}/communicationtemplates/${id}`);

    return (
        <>
            <Row className="pt-3">
                <CommunicationTemplatesTable
                    onCommunicationTemplateSelected={onCommunicationTemplateSelected}
                    hospital={currentHospital}
                    searchStore={searchStore}
                    macroScope={MacroType.Provider} />
            </Row>
            {!readOnly &&
                <Row className="pt-3">
                    <Col xs={12}>
                        <Button
                            aria-label="add hospital communcation template"
                            variant="outline-primary"
                            onClick={() => onCommunicationTemplateSelected(0)}>
                            Add Hospital Communication Template
                        </Button>
                    </Col>
                </Row>
            }

        </>
    )
})
